import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import * as React from "react";

import { tabsScrollButtonVariants } from "./tabs-variants";

interface TabsScrollButtonProps {
  direction: "left" | "right";
  disabled: boolean;
  onClick: () => void;
  dataSlot: string;
}

export function TabsScrollButton({
  direction,
  disabled,
  onClick,
  dataSlot,
}: TabsScrollButtonProps) {
  const Icon = direction === "left" ? ChevronLeftIcon : ChevronRightIcon;
  return (
    <button
      type="button"
      aria-label={`Scroll tabs ${direction}`}
      // Always rendered for stable DOM order; mirror the visual `opacity-0` in the AX tree when disabled.
      aria-hidden={disabled || undefined}
      data-slot={dataSlot}
      disabled={disabled}
      onClick={onClick}
      className={tabsScrollButtonVariants({ direction })}
    >
      <Icon className="size-4" />
    </button>
  );
}
